// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2020":"646b3e34","2779":"646b3e34"}[chunkId] + ".chunk.css";
};